/* eslint-disable @typescript-eslint/no-empty-function */
import { GwizzyCommunity } from '@common/helpers/transformGwizzyCommunity';
import { initialState } from '@react/virtual-advisor/hooks/useChatState';
import { GPTBotMode } from '@sly/core/types';
import { UseChatHelpers } from 'ai/react';
import React from 'react';

interface ChatReducerState {
  state: typeof initialState;
  dispatch: React.Dispatch<any>;
}

interface ChatboxContextProps {
  chatReducer: ChatReducerState;
  chatAI: UseChatHelpers;
  messagesEndRef: React.RefObject<HTMLDivElement> | null;
  scrollToBottom: () => void;
  gwizzyCommunity: GwizzyCommunity | null;
  handleStartGuidedFlow: (args: { name: string }) => void;
  createProfileContactActionBySlugs: (slugs: string[]) => Promise<void>;
  createProfileContactActionBySlug: (slug: string) => Promise<void>;
  getPricingRequestedListBySlugs: (slugs: string[]) => string[];
  getPricingRequestedBySlug: (slug: string) => string | null;
  onTourRequestSubmit: (values: Record<string, any>) => Promise<void>;
  onGwizzySubmit: (values: Record<string, any>) => Promise<void>;
  onAskQuestionSubmit: (values: Record<string, any>) => Promise<void>;
  onFindCommunityInAreaSubmit: (url: string) => void;
  chatbotMode: GPTBotMode;
  inputRef: React.RefObject<HTMLTextAreaElement>;
  query: any;
  defaultEventProps?: Record<string, any>;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const defaultDispatch: React.Dispatch<any> = () => {};

const defaultChatReducerState: ChatReducerState = {
  state: initialState,
  dispatch: defaultDispatch,
};

const ChatbotContext = React.createContext<ChatboxContextProps>({
  chatReducer: defaultChatReducerState,
  // use chat helpers is always included, doing this to avoid unnessary code
  chatAI: {} as UseChatHelpers,
  messagesEndRef: null,
  scrollToBottom: () => {},
  gwizzyCommunity: null,
  handleStartGuidedFlow: ({ name: _ }: { name: string }) => {},
  createProfileContactActionBySlugs: async (_: string[]) => {},
  createProfileContactActionBySlug: async (_: string) => {},
  getPricingRequestedListBySlugs: (_: string[]) => [],
  getPricingRequestedBySlug: (_: string) => '',
  onTourRequestSubmit: async (_: Record<string, any>) => {},
  onGwizzySubmit: async (_: Record<string, any>) => {},
  onAskQuestionSubmit: async (_: Record<string, any>) => {},
  onFindCommunityInAreaSubmit: (_: string) => {},
  chatbotMode: 'default',
  inputRef: { current: null },
  query: {},
  defaultEventProps: {},
});

export default ChatbotContext;
